import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: 'consentz-modal',
  templateUrl: './modal.template.html',
  styleUrls: ['./modal.styles.scss']
})
export class ModalComponent implements OnInit, AfterViewInit {
  public currentBookingOptions = localStorage.getItem('currentBookingOptions') !== 'null' && JSON.parse(localStorage.getItem('currentBookingOptions'));
  public text = JSON.parse(localStorage.getItem('settings')).terms;
  constructor() {}

  public ngOnInit(): void {
    let style: any = null;
    if (document.querySelector('#css-dynamic-class')) {
      style = document.querySelector('#css-dynamic-class');
    } else {
      style = document.createElement('style');
      style.type = 'text/css';
      style.id = 'css-dynamic-class';
    }
    style.innerHTML = `.css-dynamic-class { background-color: ${this.currentBookingOptions.secondaryInterfaceColour}!important; }`;
    document.getElementsByTagName('head')[0].appendChild(style);

    const element: any = document.querySelector('.ui-scrollpanel-bar-y');
    element.classList.add('css-dynamic-class');
  }

  public ngAfterViewInit(): void {
    document.querySelector('.custom').classList.add('scrollBorder');
  }
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/components/popups/modal/modal.component.ts